module.exports = __webpack_public_path__ + "letterFadeUnrollInLeft.gif";